import { skipToken, useMutation, useQuery } from '@tanstack/react-query';
import { getClientAnnex, updateClientAnnex } from './annex.api';
import { PDFStaticBuilderProps } from '../../common/helpers/pdf-builder';

export const useClientAnnexQuery = (client_id?: string) => {
  return useQuery({
    queryKey: ['client-annex', client_id],
    queryFn: client_id ? () => getClientAnnex(client_id) : skipToken,
    enabled: !!client_id,
  });
};

export const useUpdateClientAnnexMutation = () => {
  return useMutation({
    mutationKey: ['client-annex', 'update'],
    mutationFn: ({
      clientAnnexId,
      client_id,
      config,
    }: {
      clientAnnexId: number | undefined;
      client_id: number;
      config: PDFStaticBuilderProps;
    }) => updateClientAnnex(clientAnnexId, client_id, config),
  });
};
